module.exports = __webpack_public_path__ + "img/freespin_multiplier.13e27a65.png";